import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7f1259ed = () => interopDefault(import('../pages/a-good-company.vue' /* webpackChunkName: "pages/a-good-company" */))
const _0a076f6a = () => interopDefault(import('../pages/anker/index.vue' /* webpackChunkName: "pages/anker/index" */))
const _21195cc3 = () => interopDefault(import('../pages/anker-bundle-aktion.vue' /* webpackChunkName: "pages/anker-bundle-aktion" */))
const _298c0f36 = () => interopDefault(import('../pages/bitte-kommen-sie-spaeter-wieder.vue' /* webpackChunkName: "pages/bitte-kommen-sie-spaeter-wieder" */))
const _0fa040e0 = () => interopDefault(import('../pages/google/index.vue' /* webpackChunkName: "pages/google/index" */))
const _cfbb0306 = () => interopDefault(import('../pages/handyrechnung-aktion.vue' /* webpackChunkName: "pages/handyrechnung-aktion" */))
const _768332bb = () => interopDefault(import('../pages/handyvergleich.vue' /* webpackChunkName: "pages/handyvergleich" */))
const _fa08038c = () => interopDefault(import('../pages/infos-zum-online-kauf.vue' /* webpackChunkName: "pages/infos-zum-online-kauf" */))
const _673256bc = () => interopDefault(import('../pages/kontakt.vue' /* webpackChunkName: "pages/kontakt" */))
const _e60611a2 = () => interopDefault(import('../pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _fc92381c = () => interopDefault(import('../pages/merkliste.vue' /* webpackChunkName: "pages/merkliste" */))
const _22f6116e = () => interopDefault(import('../pages/panzerglass.vue' /* webpackChunkName: "pages/panzerglass" */))
const _79e8827a = () => interopDefault(import('../pages/preisvorteile-sichern.vue' /* webpackChunkName: "pages/preisvorteile-sichern" */))
const _1bc9d899 = () => interopDefault(import('../pages/samsung/index.vue' /* webpackChunkName: "pages/samsung/index" */))
const _2e20719a = () => interopDefault(import('../pages/samsung-cashback-aktion.vue' /* webpackChunkName: "pages/samsung-cashback-aktion" */))
const _dfac6932 = () => interopDefault(import('../pages/smart-home-entdecken.vue' /* webpackChunkName: "pages/smart-home-entdecken" */))
const _18d6c8ca = () => interopDefault(import('../pages/soundcore.vue' /* webpackChunkName: "pages/soundcore" */))
const _242e0297 = () => interopDefault(import('../pages/stabiles-internet.vue' /* webpackChunkName: "pages/stabiles-internet" */))
const _b84c6bd0 = () => interopDefault(import('../pages/themenwelten.vue' /* webpackChunkName: "pages/themenwelten" */))
const _0769b516 = () => interopDefault(import('../pages/urlaubsessentials.vue' /* webpackChunkName: "pages/urlaubsessentials" */))
const _c4022762 = () => interopDefault(import('../pages/xiaomi.vue' /* webpackChunkName: "pages/xiaomi" */))
const _93657260 = () => interopDefault(import('../pages/xiaomi-smartphones.vue' /* webpackChunkName: "pages/xiaomi-smartphones" */))
const _01bfdfc0 = () => interopDefault(import('../pages/xiaomi-zubehoer.vue' /* webpackChunkName: "pages/xiaomi-zubehoer" */))
const _55abb4c4 = () => interopDefault(import('../pages/zahlung-per-handyrechnung.vue' /* webpackChunkName: "pages/zahlung-per-handyrechnung" */))
const _040b9165 = () => interopDefault(import('../pages/anker/product-data.ts' /* webpackChunkName: "pages/anker/product-data" */))
const _484ccbd5 = () => interopDefault(import('../pages/google/product-data.js' /* webpackChunkName: "pages/google/product-data" */))
const _4904bd7e = () => interopDefault(import('../pages/hilfe/lieferstatus-und-retoure.vue' /* webpackChunkName: "pages/hilfe/lieferstatus-und-retoure" */))
const _6bbef9ce = () => interopDefault(import('../pages/magenta-black-days/page-data.js' /* webpackChunkName: "pages/magenta-black-days/page-data" */))
const _60e01b54 = () => interopDefault(import('../pages/samsung/product-data.ts' /* webpackChunkName: "pages/samsung/product-data" */))
const _39c8e8b9 = () => interopDefault(import('../pages/shop/bestaetigung.vue' /* webpackChunkName: "pages/shop/bestaetigung" */))
const _41673eaa = () => interopDefault(import('../pages/shop/brodos-zahlungsverifizierung.vue' /* webpackChunkName: "pages/shop/brodos-zahlungsverifizierung" */))
const _ed3d2776 = () => interopDefault(import('../pages/shop/fehler.vue' /* webpackChunkName: "pages/shop/fehler" */))
const _2f1ad22c = () => interopDefault(import('../pages/shop/kundenformular.vue' /* webpackChunkName: "pages/shop/kundenformular" */))
const _c02e7426 = () => interopDefault(import('../pages/shop/kundenformular/index.vue' /* webpackChunkName: "pages/shop/kundenformular/index" */))
const _216d5c49 = () => interopDefault(import('../pages/shop/kundenformular/persoenliche-daten.vue' /* webpackChunkName: "pages/shop/kundenformular/persoenliche-daten" */))
const _6f2e888e = () => interopDefault(import('../pages/shop/kundenformular/zahlungsart.vue' /* webpackChunkName: "pages/shop/kundenformular/zahlungsart" */))
const _7331b027 = () => interopDefault(import('../pages/shop/telekom-bestaetigung.vue' /* webpackChunkName: "pages/shop/telekom-bestaetigung" */))
const _31920dec = () => interopDefault(import('../pages/shop/telekom-bezahlung-information.vue' /* webpackChunkName: "pages/shop/telekom-bezahlung-information" */))
const _980718b4 = () => interopDefault(import('../pages/shop/telekom-zahlungsverifizierung.vue' /* webpackChunkName: "pages/shop/telekom-zahlungsverifizierung" */))
const _7e62e240 = () => interopDefault(import('../pages/shop/warenkorb.vue' /* webpackChunkName: "pages/shop/warenkorb" */))
const _6c328158 = () => interopDefault(import('../pages/shop/zahlungsverifizierung.vue' /* webpackChunkName: "pages/shop/zahlungsverifizierung" */))
const _76e20cdc = () => interopDefault(import('../pages/shop/zusammenfassung.vue' /* webpackChunkName: "pages/shop/zusammenfassung" */))
const _64c32d16 = () => interopDefault(import('../pages/weitere-informationen/agb-brodos.vue' /* webpackChunkName: "pages/weitere-informationen/agb-brodos" */))
const _7824a889 = () => interopDefault(import('../pages/weitere-informationen/sitemap.vue' /* webpackChunkName: "pages/weitere-informationen/sitemap" */))
const _88be1d9a = () => interopDefault(import('../pages/weitere-informationen/ueber-brodos.vue' /* webpackChunkName: "pages/weitere-informationen/ueber-brodos" */))
const _725a9fdd = () => interopDefault(import('../pages/weitere-informationen/ueber-qivicon.vue' /* webpackChunkName: "pages/weitere-informationen/ueber-qivicon" */))
const _0365c86e = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _4e9578e6 = () => interopDefault(import('../pages/magenta-moments-2024/_slug.vue' /* webpackChunkName: "pages/magenta-moments-2024/_slug" */))
const _f4e4b032 = () => interopDefault(import('../special-pages/product-details.vue' /* webpackChunkName: "" */))
const _ffccdd50 = () => interopDefault(import('../special-pages/shop-list.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/a-good-company",
    component: _7f1259ed,
    name: "a-good-company"
  }, {
    path: "/anker",
    component: _0a076f6a,
    name: "anker"
  }, {
    path: "/anker-bundle-aktion",
    component: _21195cc3,
    name: "anker-bundle-aktion"
  }, {
    path: "/bitte-kommen-sie-spaeter-wieder",
    component: _298c0f36,
    name: "bitte-kommen-sie-spaeter-wieder"
  }, {
    path: "/google",
    component: _0fa040e0,
    name: "google"
  }, {
    path: "/handyrechnung-aktion",
    component: _cfbb0306,
    name: "handyrechnung-aktion"
  }, {
    path: "/handyvergleich",
    component: _768332bb,
    name: "handyvergleich"
  }, {
    path: "/infos-zum-online-kauf",
    component: _fa08038c,
    name: "infos-zum-online-kauf"
  }, {
    path: "/kontakt",
    component: _673256bc,
    name: "kontakt"
  }, {
    path: "/maintenance",
    component: _e60611a2,
    name: "maintenance"
  }, {
    path: "/merkliste",
    component: _fc92381c,
    name: "merkliste"
  }, {
    path: "/panzerglass",
    component: _22f6116e,
    name: "panzerglass"
  }, {
    path: "/preisvorteile-sichern",
    component: _79e8827a,
    name: "preisvorteile-sichern"
  }, {
    path: "/samsung",
    component: _1bc9d899,
    name: "samsung"
  }, {
    path: "/samsung-cashback-aktion",
    component: _2e20719a,
    name: "samsung-cashback-aktion"
  }, {
    path: "/smart-home-entdecken",
    component: _dfac6932,
    name: "smart-home-entdecken"
  }, {
    path: "/soundcore",
    component: _18d6c8ca,
    name: "soundcore"
  }, {
    path: "/stabiles-internet",
    component: _242e0297,
    name: "stabiles-internet"
  }, {
    path: "/themenwelten",
    component: _b84c6bd0,
    name: "themenwelten"
  }, {
    path: "/urlaubsessentials",
    component: _0769b516,
    name: "urlaubsessentials"
  }, {
    path: "/xiaomi",
    component: _c4022762,
    name: "xiaomi"
  }, {
    path: "/xiaomi-smartphones",
    component: _93657260,
    name: "xiaomi-smartphones"
  }, {
    path: "/xiaomi-zubehoer",
    component: _01bfdfc0,
    name: "xiaomi-zubehoer"
  }, {
    path: "/zahlung-per-handyrechnung",
    component: _55abb4c4,
    name: "zahlung-per-handyrechnung"
  }, {
    path: "/anker/product-data",
    component: _040b9165,
    name: "anker-product-data"
  }, {
    path: "/google/product-data",
    component: _484ccbd5,
    name: "google-product-data"
  }, {
    path: "/hilfe/lieferstatus-und-retoure",
    component: _4904bd7e,
    name: "hilfe-lieferstatus-und-retoure"
  }, {
    path: "/magenta-black-days/page-data",
    component: _6bbef9ce,
    name: "magenta-black-days-page-data"
  }, {
    path: "/samsung/product-data",
    component: _60e01b54,
    name: "samsung-product-data"
  }, {
    path: "/shop/bestaetigung",
    component: _39c8e8b9,
    name: "shop-bestaetigung"
  }, {
    path: "/shop/brodos-zahlungsverifizierung",
    component: _41673eaa,
    name: "shop-brodos-zahlungsverifizierung"
  }, {
    path: "/shop/fehler",
    component: _ed3d2776,
    name: "shop-fehler"
  }, {
    path: "/shop/kundenformular",
    component: _2f1ad22c,
    children: [{
      path: "",
      component: _c02e7426,
      name: "shop-kundenformular"
    }, {
      path: "persoenliche-daten",
      component: _216d5c49,
      name: "shop-kundenformular-persoenliche-daten"
    }, {
      path: "zahlungsart",
      component: _6f2e888e,
      name: "shop-kundenformular-zahlungsart"
    }]
  }, {
    path: "/shop/telekom-bestaetigung",
    component: _7331b027,
    name: "shop-telekom-bestaetigung"
  }, {
    path: "/shop/telekom-bezahlung-information",
    component: _31920dec,
    name: "shop-telekom-bezahlung-information"
  }, {
    path: "/shop/telekom-zahlungsverifizierung",
    component: _980718b4,
    name: "shop-telekom-zahlungsverifizierung"
  }, {
    path: "/shop/warenkorb",
    component: _7e62e240,
    name: "shop-warenkorb"
  }, {
    path: "/shop/zahlungsverifizierung",
    component: _6c328158,
    name: "shop-zahlungsverifizierung"
  }, {
    path: "/shop/zusammenfassung",
    component: _76e20cdc,
    name: "shop-zusammenfassung"
  }, {
    path: "/weitere-informationen/agb-brodos",
    component: _64c32d16,
    name: "weitere-informationen-agb-brodos"
  }, {
    path: "/weitere-informationen/sitemap",
    component: _7824a889,
    name: "weitere-informationen-sitemap"
  }, {
    path: "/weitere-informationen/ueber-brodos",
    component: _88be1d9a,
    name: "weitere-informationen-ueber-brodos"
  }, {
    path: "/weitere-informationen/ueber-qivicon",
    component: _725a9fdd,
    name: "weitere-informationen-ueber-qivicon"
  }, {
    path: "/",
    component: _0365c86e,
    name: "index"
  }, {
    path: "/magenta-moments-2024/:slug?",
    component: _4e9578e6,
    name: "magenta-moments-2024-slug"
  }, {
    path: "/geraete/:slug?",
    component: _f4e4b032,
    name: "ProductDetails"
  }, {
    path: "/:config+",
    component: _ffccdd50,
    name: "ShopList"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
